import { render } from "./AboutStyleThree.vue?vue&type=template&id=88507a68"
import script from "./AboutStyleThree.vue?vue&type=script&lang=js"
export * from "./AboutStyleThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__